import React from 'react';
import { Route, Switch } from 'react-router-dom';

import PageWrapper from 'Dashboard/components/PageWrapper/PageWrapper';

import OnboardingWelcome from './OnboardingWelcome/OnboardingWelcome';
import OnboardingWizard from './OnboardingWizard/OnboardingWizard';
import OnboardingPrivateRoute from './OnboardingPrivateRoute/OnboardingPrivateRoute';
import UserChooseMembership from './UserChooseMembership/UserChooseMembership';
import UserConfirmation from './UserConfirmation/UserConfirmation';
import UserInvitationEdit from './UserInvitationEdit/UserInvitationEdit';
// import UserInvitationPage from './UserInvitationPage/UserInvitationPage';
import SignupCheckEmail from './SignupCheckEmail/SignupCheckEmail';
import SignupCheckEmailDesktopOnly from './SignupCheckEmail/SignupCheckEmailDesktopOnly';
import OpenLinkOnDesktop from './SignupCheckEmail/OpenLinkOnDesktop';

// Layouts
import RouteLayoutWrapper from 'Shared/route_layouts/RouteLayoutWrapper';
import LoggedOutWrapper from 'Shared/route_layouts/LoggedOutWrapper';

function Onboarding() {
  return (
    <Switch>
      {/* <Route exact path={['/user/invitation/accept', '/invites/:slug']} component={UserInvitationPage} /> */}
      <Route exact path="/onboarding/wizard" component={OnboardingWizard} />
      <RouteLayoutWrapper path={['/user/confirm/:slug?']} layout={LoggedOutWrapper} component={SignupCheckEmail} />
      <RouteLayoutWrapper
        path={['/user/confirmation/new', '/user/confirmation']}
        layout={LoggedOutWrapper}
        component={UserConfirmation}
      />
      <RouteLayoutWrapper
        exact
        path="/user/choose_membership"
        layout={LoggedOutWrapper}
        component={UserChooseMembership}
      />
      <PageWrapper>
        <Route exact path="/user/confirm_desktop_only/:slug?" component={SignupCheckEmailDesktopOnly} />
        <Route exact path="/mobile_handoff/:slug" component={OpenLinkOnDesktop} />
        <Route exact path="/user/invitation/edit" component={UserInvitationEdit} />
        <Route exact path="/user/invitation/welcome" component={OnboardingWelcome} />
        <Route exact path="/user/invitation" component={UserInvitationEdit} />
        <OnboardingPrivateRoute exact path="/onboarding/welcome">
          <OnboardingWelcome />
        </OnboardingPrivateRoute>
      </PageWrapper>
    </Switch>
  );
}

export default Onboarding;
